import type { FC } from "react";
import { Navigate } from "react-router-dom";
import { useGoalsRight } from "web_myplann/Api/Rights/RightsProvider";
import { ChatListPage } from "web_myplann/Chat/Pages/ChatListPage";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { getRoute } from "web_myplann/Infrastructure/Utils/UrlUtils";

export const ChatListPageResolver: FC = () => {
	const hasGoalsRight = useGoalsRight();

	return hasGoalsRight ? (
		<ChatListPage />
	) : (
		<Navigate to={getRoute(Routing.Advisor)} replace />
	);
};
